import { useSelector } from "react-redux";
import DashboardHeader from "../../../components/dashboard/dashboardHeader";
import { Form, Formik } from "formik";
import { PMField } from "../../../components/utils/PMField";
import toast from "react-hot-toast";
import { dispatchWithToast } from "../../../components/Utils";
import { updateUserAsync } from "../../../slices/user";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import PMListbox from "../../../components/utils/PMListbox";
import {
  CheckBadgeIcon,
  MapPinIcon,
  PencilIcon,
  BookOpenIcon,
  UserGroupIcon,
  ShieldCheckIcon,
  DocumentTextIcon,
} from "@heroicons/react/24/outline";
import { FormikSaveBar } from "../../../components/utils/FormikSaveBar";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export const UserProfile = (props) => {
  const currentUser = useSelector((state) => state.session.currentUser);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handlePersonalhåndbokClick = () => {
    navigate("/dashboard/quality/employee-handbook");
  };

  function UserForm({ disabled }) {
    return (
      <Formik
        enableReinitialize
        initialValues={{
          id: currentUser?.id,
          name: currentUser?.name,
          email: currentUser?.email,
          preferred_maps_service: currentUser?.preferred_maps_service,
          submit: null,
        }}
        validationSchema={Yup.object({
          email: Yup.string().email(),
          // .required(t("Email is required")),
        })}
        onSubmit={(values, helpers) => {
          try {
            dispatchWithToast(
              dispatch(updateUserAsync(values))
              // (data) => onRefresh(data),
              // onClose
            );
          } catch (err) {
            toast.error("Something went wrong...");
            helpers.setStatus({ success: false });
            helpers.setErrors({ submit: err.message });
            // helpers.setSubmitting(false);
          }
        }}
      >
        {(formik) => (
          <Form>
            <div className="grid grid-cols-6 gap-6 mt-10 ">
              <div className="col-span-6 sm:col-span-6">
                <PMField
                  name="name"
                  type="text"
                  label={"Navn"}
                  {...formik}
                  disabled={disabled}
                />
              </div>

              <div className="col-span-6 sm:col-span-6">
                <PMField
                  name="email"
                  type="text"
                  label={"E-post"}
                  {...formik}
                  disabled={disabled}
                />
              </div>

              <div className="col-span-6 sm:col-span-3">
                <PMField
                  name="address"
                  type="text"
                  label={"Adresse"}
                  {...formik}
                  disabled={disabled}
                />
              </div>

              <div className="col-span-6 sm:col-span-3">
                <PMField
                  name="address2"
                  type="text"
                  label={"Adresse 2"}
                  {...formik}
                  disabled={disabled}
                />
              </div>

              <div className="col-span-6 sm:col-span-4">
                <PMField
                  name="postal"
                  type="text"
                  label={"Postnr."}
                  {...formik}
                  disabled={disabled}
                />
              </div>

              <div className="col-span-6 sm:col-span-2">
                <PMField
                  name="place"
                  type="text"
                  label={"Sted"}
                  {...formik}
                  disabled={disabled}
                />
              </div>
            </div>

            {/* <FormikSaveBar {...formik} /> */}
          </Form>
        )}
      </Formik>
    );
  }

  return (
    <>
      <DashboardHeader
        subtitle={currentUser.name}
        actions={[]}
        title={"Brukerprofil"}
        // meta={headerMeta}
        // mainButton={{
        //   label: "New",
        //   action: () => setDeviationNewDialogOpen(true),
        //   path: null,
        //   color: "",
        //   icon: PlusIcon,
        // }}
      >
        <div className="mx-auto mt-8 grid max-w-3xl grid-cols-1 gap-6 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
          <div className="space-y-6 lg:col-span-3 lg:col-start-1 sm:col-span-3 bg-white shadow rounded-xl px-5 py-5">
            <UserForm disabled />
          </div>

          {/* Personalhåndbok Section */}
          <div className="space-y-6 lg:col-span-3 lg:col-start-1 sm:col-span-3">
            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-6 border border-blue-200">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="bg-blue-100 p-3 rounded-lg">
                    <BookOpenIcon className="h-6 w-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">
                      {t("Personalhåndbok")}
                    </h3>
                    <p className="text-sm text-gray-600">
                      {t("personalhåndbok.description")}
                    </p>
                  </div>
                </div>
                <button
                  onClick={handlePersonalhåndbokClick}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 flex items-center space-x-2"
                >
                  <span>{t("Open")}</span>
                  <BookOpenIcon className="h-4 w-4" />
                </button>
              </div>

              {/* Quick Access Cards */}
              <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
                <div className="bg-white rounded-lg p-4 border border-gray-200 hover:border-blue-300 transition-colors duration-200">
                  <div className="flex items-center space-x-3">
                    <ShieldCheckIcon className="h-5 w-5 text-green-600" />
                    <div>
                      <h4 className="font-medium text-gray-900">
                        {t("HMS Guidelines")}
                      </h4>
                      <p className="text-xs text-gray-500">
                        {t("Safety procedures and guidelines")}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-lg p-4 border border-gray-200 hover:border-blue-300 transition-colors duration-200">
                  <div className="flex items-center space-x-3">
                    <DocumentTextIcon className="h-5 w-5 text-blue-600" />
                    <div>
                      <h4 className="font-medium text-gray-900">
                        {t("Instructions")}
                      </h4>
                      <p className="text-xs text-gray-500">
                        {t("Company policies and procedures")}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-lg p-4 border border-gray-200 hover:border-blue-300 transition-colors duration-200">
                  <div className="flex items-center space-x-3">
                    <UserGroupIcon className="h-5 w-5 text-purple-600" />
                    <div>
                      <h4 className="font-medium text-gray-900">
                        {t("Colleagues")}
                      </h4>
                      <p className="text-xs text-gray-500">
                        {t("Team overview and contacts")}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DashboardHeader>
    </>
  );
};
